import { Routes } from '@angular/router';

import { authGuard, authorizedGuard, isOfflineGuard } from './router/guards';
import { clearSessionIdResolver } from './router/resolvers';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/auth/auth.routes').then((m) => m.authRoutes),
    canActivate: [isOfflineGuard],
    resolve: { cleanSession: clearSessionIdResolver },
  },
  {
    path: 'offline',
    loadComponent: () =>
      import('./shared/pages/offline/offline.component').then(
        (c) => c.OfflineComponent,
      ),
    canActivate: [isOfflineGuard],
  },
  {
    path: 'scheduler',
    loadChildren: () =>
      import('./modules/scheduler/scheduler.routes').then(
        (m) => m.schedulerRoutes,
      ),
    canActivate: [isOfflineGuard, authGuard, authorizedGuard],
  },
  {
    path: 'capacity',
    loadChildren: () =>
      import('./modules/capacities/capacities.routes').then(
        (m) => m.capacitiesRoutes,
      ),
    canActivate: [isOfflineGuard, authGuard, authorizedGuard],
    resolve: { cleanSession: clearSessionIdResolver },
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./modules/admin/admin.routes').then((m) => m.adminRoutes),
    canActivate: [isOfflineGuard, authGuard, authorizedGuard],
    resolve: {
      cleanSession: clearSessionIdResolver,
    },
  },
  {
    path: 'public',
    loadChildren: () =>
      import('./modules/public/public.routes').then((m) => m.publicRoutes),
    canActivate: [isOfflineGuard],
  },
  { path: '**', redirectTo: 'scheduler' },
];
